const parseTimestamp = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }

  const timestamp = new Date(value).getTime();
  if (!Number.isNaN(timestamp)) {
    return timestamp;
  }

  return typeof value === "number" ? value : null;
};

const parseSerialNumber = (product) => {
  const rawValue = product?.srNo ?? product?.SrNo ?? product?.srno ?? product?.SRNO;
  if (rawValue === undefined || rawValue === null || rawValue === "") {
    return null;
  }

  const parsed = Number(rawValue);
  return Number.isNaN(parsed) ? null : parsed;
};

const getProductTimestamp = (product) =>
  parseTimestamp(
    product?.createdDate ||
      product?.CreatedDate ||
      product?.createdAt ||
      product?.CreatedAt ||
      product?.createDate ||
      product?.createDateTime ||
      product?.updatedDate ||
      product?.UpdatedDate ||
      product?.updatedAt ||
      product?.UpdatedAt,
  );

export const sortProductsBySerialOrCreatedDate = (list) => {
  if (!Array.isArray(list)) {
    return [];
  }

  return list.slice().sort((first, second) => {
    const firstSerial = parseSerialNumber(first);
    const secondSerial = parseSerialNumber(second);

    if (firstSerial !== null && secondSerial !== null && firstSerial !== secondSerial) {
      return firstSerial - secondSerial;
    }

    if (firstSerial !== null && secondSerial === null) {
      return -1;
    }

    if (firstSerial === null && secondSerial !== null) {
      return 1;
    }

    const firstTimestamp = getProductTimestamp(first);
    const secondTimestamp = getProductTimestamp(second);

    if (firstTimestamp !== null && secondTimestamp !== null && firstTimestamp !== secondTimestamp) {
      return secondTimestamp - firstTimestamp;
    }

    if (firstTimestamp === null && secondTimestamp !== null) {
      return 1;
    }

    if (firstTimestamp !== null && secondTimestamp === null) {
      return -1;
    }

    const firstId = Number(first?.productId ?? first?.product_Id ?? 0);
    const secondId = Number(second?.productId ?? second?.product_Id ?? 0);
    return secondId - firstId;
  });
};
